module.exports = __webpack_public_path__ + "img/iocn-1.a6b39b09.png";